document.addEventListener('DOMContentLoaded', function () {
  // Listen for clicks on labels for variant options
  document.body.addEventListener('click', function (event) {
    if (event.target.matches('.product-card-variant-option + label')) {
      const label = event.target;
      const input = label.previousElementSibling;

      // Simulate a click on the radio input
      if (input && input.matches('.product-card-variant-option')) {
        input.checked = true; // Set the radio as checked
        input.dispatchEvent(new Event('change', { bubbles: true })); // Trigger the change event
      }
    }
  });

  // Handle the change event for the radio input
  document.body.addEventListener('change', function (event) {
    if (event.target.matches('.product-card-variant-option')) {
      const selectedOption = event.target;
      const cardContent = selectedOption.closest('.card__content');

      // Update the hidden input with the selected variant ID
      const hiddenInput = cardContent.querySelector('.updateSelectOptionValue');
      if (hiddenInput) {
        hiddenInput.value = selectedOption.getAttribute('data-value');
        console.log('Variant ID updated:', hiddenInput.value);
      } else {
        console.error('Hidden input not found in card content.');
      }

      // Update the displayed price
      const priceElement = cardContent.querySelector('.card-price');
      const selectedPrice = selectedOption.getAttribute('data-price');
      if (priceElement) {
        if (window.onlyShowPoints) {
          const basePrice = parseFloat(selectedPrice.replace(/[^0-9.]/g, ''));
          const isEducation = selectedOption.getAttribute('data-education') === 'true';
          const multiplier = isEducation ? 100 : 20;
          const points = Math.round(basePrice * multiplier);
          priceElement.textContent = points.toLocaleString('en-US') + ' Points';
        } else {
          priceElement.textContent = selectedPrice;
        }
      }

      // Handle the compare-at price
      const compareAtPrice = selectedOption.getAttribute('data-compare_at_price');
      const comparePriceElement = cardContent.querySelector('.original-price.price-item');
      if (comparePriceElement) {
        if (compareAtPrice && compareAtPrice.trim() !== '') {
          comparePriceElement.textContent = compareAtPrice;
          comparePriceElement.style.display = 'inline';
          console.log('Compare-at price updated to:', compareAtPrice);
        } else {
          comparePriceElement.style.display = 'none';
        }
      }

      // Update inventory status and button state
      const inventory = selectedOption.getAttribute('data-inventory');
      const quickAddButton = cardContent.querySelector('.quick-add__submit span');
      const quickAddParent = cardContent.querySelector('.quick-add__submit');
      const actionElement = cardContent.querySelector('.action');

      if (inventory == 0 || inventory === 'false' || inventory < 0) {
        if (quickAddButton) quickAddButton.textContent = 'Out of stock';
        if (quickAddParent) quickAddParent.setAttribute('disabled', true);
        if (actionElement) actionElement.classList.add('sold_out');
        console.log('Inventory status: Out of stock');
      } else {
        if (quickAddButton) quickAddButton.textContent = 'Add to bag';
        if (quickAddParent) quickAddParent.removeAttribute('disabled');
        if (actionElement) actionElement.classList.remove('sold_out');
        console.log('Inventory status: In stock');
      }

      // Ensure only the selected radio has the checked attribute
      const allVariantRadios = cardContent.querySelectorAll('.product-card-variant-option');
      allVariantRadios.forEach((radio) => radio.removeAttribute('checked'));
      selectedOption.setAttribute('checked', 'checked');
    }
  });

  // Listen for clicks on "Add to Bag" buttons
  document.body.addEventListener('click', function (event) {
    if (event.target.matches('.quick-add__submit')) {
      event.preventDefault();

      const button = event.target;
      const cardContent = button.closest('.card__content');
      const variantIdInput = cardContent.querySelector('.updateSelectOptionValue');
      const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      // Validate the variant ID
      if (!variantIdInput || !variantIdInput.value) {
        console.error('No variant selected or missing input.');
        return;
      }
      console.log('Variant ID to be added:', variantIdInput.value);

      // Show loading state
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      const loadingSpinner = button.querySelector('.loading__spinner');
      if (loadingSpinner) loadingSpinner.classList.remove('hidden');

      // Prepare FormData for the request
      const formData = new FormData();
      formData.append('id', variantIdInput.value);

      if (cartDrawer) {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender().map((section) => section.id) : ''
        );
        formData.append('sections_url', window.location.pathname);
        if (cartDrawer.setActiveElement) cartDrawer.setActiveElement(document.activeElement);
      }

      console.log('Form data for request:', Array.from(formData.entries()));

      // Fetch configuration
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      };

      // Add to cart
      fetch('/cart/add.js', config)
        .then((response) => {
          if (!response.ok) {
            return response.json().then((error) => {
              console.error('Error response:', error);
              throw new Error(`Add to cart failed: ${error.message || 'Unknown error'}`);
            });
          }
          return response.json();
        })
        .then((response) => {
          console.log('Add to cart successful:', response);

          // Handle cart drawer updates
          if (window.showToast) {
            window.showToast();
          } else if (cartDrawer) {
            cartDrawer.renderContents(response);
          } else {
            window.location = window.routes.cart_url || '/cart';
          }
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
        })
        .finally(() => {
          // Reset button state
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
          if (loadingSpinner) loadingSpinner.classList.add('hidden');
        });
    }
  });
});
